// extracted by mini-css-extract-plugin
export default {"paragraph":"style_paragraph__3kcIn","word":"style_word__0gl+J","shadow":"style_shadow__czrzV"};